import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {convertToCurrencyFormat} from "./ownQueueUtility";
import {getOwnQueueStatusTextByValue} from "./ownQueueConstants";
import {isRmtcAdmin} from "@/Utilities/LocalStorage/storageUtilities";

export const ownCatalogQueueModel = ({
                                         ownCatalogItemId,
                                         ownQueueStatus,
                                         cost,
                                         id,
                                         title,
                                         patronName,
                                     }: Record<string, unknown> = {}) => ({
    ownCatalogItemId,
    details: createOwnQueueDetails({
        cost: cost as number | null | undefined,
        ownQueueStatus: ownQueueStatus as string | number | undefined,
        patronName: patronName as string | null | undefined,
        isAdmin: isRmtcAdmin(),
    }),
    id,
    title,
});

export const ownQueueAssignModel = ({
                                     shippingLocationId = "",
                                  }: { shippingLocationId?: string } = {}) => ({
    shippingLocationId,
});
export const emptyOwnQueueAssignModel = ownQueueAssignModel();

function returnPatronName(patronName: string | null | undefined) {
    const hasPatronName = !isNullOrUndefined(patronName) && patronName !== "";
    return hasPatronName ? `<div><b>${patronName}</b> (Patron)</div>` : "";
}

function returnCost(cost: number | null | undefined) {
    const hasCost = !isNullOrUndefined(cost);
    return hasCost ? `<div><b>${convertToCurrencyFormat(cost)}</b> (Cost)</div>` : "";
}

function returnOwnQueueStatus(queueStatus: string | number | undefined) {
    const hasStatus = !isNullOrUndefined(queueStatus);
    return hasStatus ? `<div><b>${getOwnQueueStatusTextByValue(queueStatus)}</b> (Status)</div>` : "";
}

function createOwnQueueDetails({cost, ownQueueStatus, patronName, isAdmin}: { cost?: number | null; ownQueueStatus?: string | number; patronName?: string | null; isAdmin?: boolean }) {
    let details = "";

    details += returnPatronName(patronName);
    if (isAdmin) details += returnCost(cost);
    details += returnOwnQueueStatus(ownQueueStatus);

    return details;
}
